import { useState } from 'react';
import '../styles/NavBar.css';
import logo from '../assets/golden-state-logo.svg';
import { PhoneIcon } from './Icons';
import { scrollToEstimate, scrollToSection } from '../utils/navigation';

const navigationItems = [
  { label: 'Services', target: 'Services-Start', offset: 96 },
  { label: 'About Us', target: 'WhyChoose-Container', offset: 0 },
  { label: 'Doors & Openers', target: 'CardSet', offset: 0 },
  { label: 'Contact', target: 'Estimate-Start', estimate: true },
  { label: 'Design Your Door', href: 'https://www.amarr.com/us/en/design-your-garage-door' },
];

export default function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = (event, item) => {
    event.preventDefault();
    setMenuOpen(false);
    if (item.href) {
      window.location.assign(item.href);
      return;
    }
    if (item.estimate) {
      scrollToEstimate();
      return;
    }
    scrollToSection(item.target, item.offset);
  };

  const returnToTop = (event) => {
    event.preventDefault();
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav id="Nav" className="NavBar-Background" aria-label="Primary navigation">
      <a className="NavBar-Brand" href="#top" onClick={returnToTop} aria-label="Golden State Garage Doors, back to top">
        <img src={logo} className="NavBar-Home" alt="Golden State Garage Doors" />
      </a>

      <button
        className="NavBar-MenuToggle"
        type="button"
        aria-expanded={menuOpen}
        aria-controls="primary-navigation"
        aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
        onClick={() => setMenuOpen((open) => !open)}
      >
        <span />
        <span />
        <span />
      </button>

      <ul id="primary-navigation" className={`NavBar-UnorderedList${menuOpen ? ' is-open' : ''}`}>
        {navigationItems.map((item) => (
          <li key={item.label}>
            <a
              className="NavBar-Link"
              href={item.href || `#${item.target}`}
              onClick={(event) => navigate(event, item)}
            >
              {item.label}
            </a>
          </li>
        ))}
        <li className="NavBar-MobilePhone">
          <a className="NavBar-Link" href="tel:4089690882">Call (408) 969-0882</a>
        </li>
      </ul>

      <a className="NavBar-Button" href="tel:4089690882">
        <PhoneIcon /> <span>(408) 969-0882</span>
      </a>
    </nav>
  );
}
